import {Component,Input, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {TransactionService} from "../../services/transaction.service";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-bet-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css']
})
export class BetDetailComponent implements OnInit {
  @Input() event_id: number;
  @Input() subtype: string;
  @Input() runner_name: string;
  @Input() winner: string;
  betdata:any = {};
  filter_bets:any=[];
  totalbets:number = 0;
  totalwins:number = 0;

  constructor(public activeModal: NgbActiveModal, private transactionService: TransactionService) {
  }

  ngOnInit(): void {
    this.getbetDataRequests();
  }

  getbetDataRequests() {
    this.transactionService.getbetData(this.event_id,this.subtype,this.runner_name).subscribe((res: any) => {
      this.betdata = res;
      this.filter_bets = this.betdata.bets;
      this.totalbets = this.filter_bets.length;
      //this.totalwins = this.filter_bets.reduce((count:number, item:any) => (item.is_won === 1 ? count + 1 : count), 0);
      this.totalwins = this.filter_bets.reduce((sum:any, entry:any) => sum + (entry.profit_loss || 0), 0);
    })
  }

  filterBetsByType(event: any) {
    const filterType = (event.target as HTMLInputElement).value;
    if (filterType === 'all') {
      this.filter_bets = this.betdata.bets;
    } else if(filterType === 'deleted'){
      this.filter_bets = this.betdata.bets.filter((bet:any) => bet.from === "deleted");
    } else {
      this.filter_bets = this.betdata.bets.filter((bet:any) => bet.type === filterType);
    }
    this.totalbets = this.filter_bets.length;
    this.totalwins = this.filter_bets.reduce((sum:any, entry:any) => sum + (entry.profit_loss || 0), 0);
  }  
  
}
